import { render, staticRenderFns } from "./BaseExam.vue?vue&type=template&id=c0c808f8&"
import script from "./BaseExam.vue?vue&type=script&lang=js&"
export * from "./BaseExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports